export default "<div class=\"card\">\r\n    <app-persona-clientes style=\"margin: 1.5vw;\" [esDatosFiscales]=\"true\"> </app-persona-clientes>\r\n</div>";